import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import {
    IPersonRequestDto,
    IStringInt32KeyValuePair,
    AgencyPersonMapping,
    PeopleStatus,
    PersonAgenciesDto,
    StatusHistory,
    PersonResponseDtoGridResponseBase,
    PersonType,
    Participants,
    AgencyAdminProfile,
    DesignatedRepresentativeProfile,
    ParticipantDesignatedRepresentative,
    CaregiverDetails,
    Relationships,
    ServiceFacilitatorProfile,
    CaregiverEmployerList,
    ICaregiverDetails,
    IParticipants,
    ICaregiverProfile,
    EmployerOfRecordResponse,
    CustEmpRelResponseDtoGridResponseBase,
    ProgramCoordinatorDto,
    IProgramCoordinatorProfile,
    IProgramCoordinatorDto,
} from 'src/app/core/services/peopleapi/peoplefunctionapi.services';

import {
    PayRateModel,
    GridResponseBaseOfEinList
} from 'src/app/core/services/u2api.services';
import { Dictionary } from 'src/app/shared/utilities/dictionary';

export interface IPersonState {
    PersonSearchCriteria: IPersonRequestDto;
    PersonSearchFilter: CompositeFilterDescriptor;
    Persons: PersonResponseDtoGridResponseBase;
    PersonType: Array<IStringInt32KeyValuePair>;
    PersonAAAgencies: PersonAgenciesDto;
    PersonSFAgencies: PersonAgenciesDto;

    statusHistory: Array<StatusHistory>;
    statusDRHistory: Array<StatusHistory>;
    AAProfile: AgencyAdminProfile;
    AgencyAdminAgencies: Dictionary;
    SFAgencies: Dictionary;
    SFCaseLoad: Dictionary;
    DesignatedRepresentativePerson: PersonType;
    PayRate: PayRateModel[];
    DRProfile: DesignatedRepresentativeProfile[];
    SFProfile: ServiceFacilitatorProfile[];
    Participants: IParticipants;
    EmployerOfRecordResponse: EmployerOfRecordResponse[];
    Error: string;
    ParticipantCaregiverRelation: CustEmpRelResponseDtoGridResponseBase;
    ParticipantEmployerOfRecordRelation: GridResponseBaseOfEinList;
    ParticicpantDrRelation: ParticipantDesignatedRepresentative[];
    DRParticicpantRelation: Array<ParticipantDesignatedRepresentative>;
    DRParticipantRel: Dictionary;
    CaregiverDetails: ICaregiverDetails;
    EmployerOfRecordParticicpantRelation: Array<Relationships>;
    EmployerOfRecordParticipantRel: Dictionary;
    EmployerOfRecordCaregiverRelation: Array<Relationships>;
    EmployerOfRecordCaregiverRel: Dictionary;
    CaregiverProfile: ICaregiverProfile;
    CaregiverParticipantRelation: CustEmpRelResponseDtoGridResponseBase;
    CaregiverEmployerOfRecordRelation: CaregiverEmployerList[];
    ProgramCoordinatorDetails: IProgramCoordinatorDto;
    ProgramCoordinatorProfile: IProgramCoordinatorProfile;
}

export class PersonState implements IPersonState {
    PersonSearchCriteria: IPersonRequestDto;
    PersonSearchFilter: CompositeFilterDescriptor;
    Persons: PersonResponseDtoGridResponseBase;
    PersonType: Array<IStringInt32KeyValuePair>;
    PersonAAAgencies: PersonAgenciesDto;
    PersonSFAgencies: PersonAgenciesDto;
    statusHistory: Array<StatusHistory>;
    statusDRHistory: Array<StatusHistory>;
    AAProfile: AgencyAdminProfile;
    DRProfile: AgencyAdminProfile[];
    SFProfile: ServiceFacilitatorProfile[];
    AgencyAdminAgencies = new Dictionary();
    SFAgencies = new Dictionary();
    SFCaseLoad = new Dictionary();
    DesignatedRepresentativePerson: PersonType;
    PayRate: PayRateModel[];
    Participants: Participants;
    EmployerOfRecordResponse: EmployerOfRecordResponse[];
    Error: string;
    ParticipantCaregiverRelation: CustEmpRelResponseDtoGridResponseBase;
    ParticipantEmployerOfRecordRelation: GridResponseBaseOfEinList;
    ParticicpantDrRelation: ParticipantDesignatedRepresentative[];
    DRParticicpantRelation: Array<ParticipantDesignatedRepresentative>;
    DRParticipantRel = new Dictionary();
    CaregiverDetails: CaregiverDetails;
    CaregiverProfile: ICaregiverProfile;
    EmployerOfRecordParticicpantRelation: Array<Relationships>;
    EmployerOfRecordParticipantRel = new Dictionary();
    EmployerOfRecordCaregiverRelation: Array<Relationships>;
    EmployerOfRecordCaregiverRel = new Dictionary();
    CaregiverParticipantRelation: CustEmpRelResponseDtoGridResponseBase;
    CaregiverEmployerOfRecordRelation: CaregiverEmployerList[];
    ProgramCoordinatorDetails: ProgramCoordinatorDto;
    ProgramCoordinatorProfile: IProgramCoordinatorProfile;
}



export interface IPersonAgency {
    AgencyPersonMapping: Array<AgencyPersonMapping>;
    Id: number;
    PersonId: string;
    Status: PeopleStatus;
    StatusStartDate: Date;
    StatusEndDate: Date;
    Comments: string;
    StatusChangeReason: string;
}

export class PersonAgency implements IPersonAgency {
    AgencyPersonMapping: Array<AgencyPersonMapping>;
    Id: number;
    PersonId: string;
    Status: PeopleStatus;
    StatusStartDate: Date;
    StatusEndDate: Date;
    Comments: string;
    StatusChangeReason: string;
}
